module.exports = __webpack_public_path__ + "static/img/progress-en.d92ce0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/progress/progress-en.png
// module id = 5bl/
// module chunks = 1